import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TopHeader from '../template/TopHeader';
import SettingsTopNav from './SettingsTopNav';
import useSettingsTabs from './useSettingsTabs';

/**
 * Hub search deep link: when the settings hub opens a page for a section hit
 * it passes { scrollToHeading } in location.state. Find the first heading on
 * the page whose text starts with it, scroll there and flash it. Pages are
 * untouched; headings need no ids.
 */
function useScrollToHeading(location) {
    const heading = location && location.state && location.state.scrollToHeading;
    useEffect(() => {
        if (!heading) return undefined;
        const want = heading.toLowerCase();
        let tries = 0;
        let lastTop = null;
        let timer;
        const find = () => Array.from(document.querySelectorAll('.catalogue-content-container h1, .catalogue-content-container h2, .catalogue-content-container h3'))
            .find(n => (n.textContent || '').trim().toLowerCase().startsWith(want));
        const attempt = () => {
            const hit = find();
            // Pages fetch their data after mount, so wait until the heading is
            // present and has stopped moving before scrolling to it.
            const top = hit ? Math.round(hit.getBoundingClientRect().top + window.scrollY) : null;
            if (hit && top === lastTop) {
                hit.scrollIntoView({ block: 'center' });
                const target = hit.closest('.settings-card') || hit;
                target.style.transition = 'box-shadow 0.3s ease';
                target.style.boxShadow = '0 0 0 2px #007EA0';
                setTimeout(() => { target.style.boxShadow = ''; }, 1600);
                // Drop the state so a refresh does not scroll again. Written
                // straight to the browser history: going through the router
                // would re-render the route and reset the scroll we just set.
                try {
                    const h = window.history.state || {};
                    window.history.replaceState({ ...h, state: {} }, '');
                } catch (e) { /* ignore */ }
                return;
            }
            lastTop = top;
            if (tries++ < 30) timer = setTimeout(attempt, 200);
        };
        attempt();
        return () => clearTimeout(timer);
    }, [heading]); // eslint-disable-line react-hooks/exhaustive-deps
}

function SettingsPageLayout({ activeTab, navActions, children, user, history, location, ...props }) {
    const { tabs } = useSettingsTabs(user);
    useScrollToHeading(location);

    return (
        <div className="h_n catalogue-no-header settings-fixed-header settings-shell">
            <div className="body_container cm_bg_white">
                <TopHeader title="Settings" headerButtonStatus={false} {...props} user={user} history={history} />
                <div className="catalogue-page-wrapper">
                    <SettingsTopNav
                        activeTab={activeTab}
                        tabs={tabs}
                        onTabChange={(path) => history.push(path)}
                    >
                        {navActions}
                    </SettingsTopNav>
                    <div className="catalogue-content-container">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(SettingsPageLayout));
